export enum AuthStorageEnum {
  token = 'auth:token',
  user = 'auth:user',
}
